export const AcessoChoiceLabels: { [key: string]: string } = {
  SOCIOECONOMICO: "Socioeconômico",
  LISTA_EMPREENDIMENTO: "Lista de Empreendimento",
  MAPA_INTERATIVO: "Mapa Interativo",
  RELATORIO_PDF: "Relatório em PDF",
  TABELAS_PRECIFICACAO: "Tabelas de Precificação",
  IA_INTEGRADA: "IA Integrada",
};

export const AcessoChoiceNumericToStringKey: { [key: number]: string } = {
  1: 'SOCIOECONOMICO',
  2: 'LISTA_EMPREENDIMENTO',
  3: 'MAPA_INTERATIVO',
  4: 'RELATORIO_PDF',
  5: 'TABELAS_PRECIFICACAO',
  6: 'IA_INTEGRADA',
};

export interface Plano {
  id: number;
  nome: string;
  descricao: string;
  valor: string;
  max_membros: number;
  quantidade_cidade: number;
  quantidade_segmento: number;
  acessos: string[];
  created: string;
  modified: string;
  limite_cidades_extra: number;
  limite_segmentos_extra: number;
  valor_cidade_adicional: string;
  valor_segmento_adicional: string;
  created_by: number;
  modified_by: number;
}

export interface PlanoInput {
  nome: string;
  descricao: string;
  valor: string;
  max_membros: number;
  quantidade_cidade: number;
  quantidade_segmento: number;
  acessos: string[];
  limite_cidades_extra: number;
  limite_segmentos_extra: number;
  valor_cidade_adicional: string;
  valor_segmento_adicional: string;
}

export interface PlanoUpdateInput extends Partial<PlanoInput> {}

export interface PaginatedPlanoResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Plano[];
}
 